// extracted by mini-css-extract-plugin
export default {"drawerBody":"PC9LY7JeKW3Yu5FsZuEJ__drawerBody___"};